(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["art-file-uploader"] && !Shopify.designMode) return;
  try {
    (function () {
    function getFileIcon(file) {
      const ext = file.name.split('.').pop().toLowerCase();
      if (ext === 'pdf') return 'PDF';
      if (ext === 'doc' || ext === 'docx') return 'DOC';
      if (ext === 'dxf' || ext === 'dwg') return 'CAD';
      return 'FILE';
    }

    function truncateName(name, max) {
      if (name.length <= max) return name;
      const ext = name.lastIndexOf('.') > -1 ? name.slice(name.lastIndexOf('.')) : '';
      return name.slice(0, max - ext.length - 3) + '...' + ext;
    }

    function initFileUpload(dropzone) {
      if (dropzone.dataset.artFileUploaderInitialized === 'true') return;
      dropzone.dataset.artFileUploaderInitialized = 'true';

      const inputId = dropzone.dataset.inputId;
      const input = document.getElementById(inputId);
      const previewGrid = dropzone.querySelector('.art-file-uploader__preview-grid');
      if (!input || !previewGrid || !window.DataTransfer) return;

      const originallyRequired = input.hasAttribute('required');
      let selectedFiles = new DataTransfer();

      function syncInput() {
        input.files = selectedFiles.files;
        input.required = originallyRequired && selectedFiles.files.length === 0;
        input.toggleAttribute('aria-required', input.required);
      }

      function renderPreviews() {
        previewGrid.innerHTML = '';
        Array.from(selectedFiles.files).forEach(function (file, index) {
          const item = document.createElement('div');
          item.className = 'art-file-uploader__preview-item';

          if (file.type.startsWith('image/')) {
            const img = document.createElement('img');
            img.className = 'art-file-uploader__thumb';
            img.alt = file.name;
            const reader = new FileReader();
            reader.onload = function (event) {
              img.src = event.target.result;
            };
            reader.readAsDataURL(file);
            item.appendChild(img);
          } else {
            const icon = document.createElement('div');
            icon.className = 'art-file-uploader__icon';
            icon.textContent = getFileIcon(file);
            item.appendChild(icon);
          }

          const name = document.createElement('span');
          name.className = 'art-file-uploader__name';
          name.textContent = truncateName(file.name, 18);
          name.title = file.name;
          item.appendChild(name);

          const removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'art-file-uploader__remove';
          removeBtn.setAttribute('aria-label', 'Remove ' + file.name);
          removeBtn.innerHTML = '&times;';
          removeBtn.addEventListener('click', function () {
            const updated = new DataTransfer();
            Array.from(selectedFiles.files).forEach(function (existingFile, existingIndex) {
              if (existingIndex !== index) updated.items.add(existingFile);
            });
            selectedFiles = updated;
            syncInput();
            renderPreviews();
          });
          item.appendChild(removeBtn);

          previewGrid.appendChild(item);
        });
      }

      function addFiles(files) {
        Array.from(files).forEach(function (file) {
          selectedFiles.items.add(file);
        });
        syncInput();
        renderPreviews();
      }

      input.addEventListener('change', function () {
        addFiles(input.files);
      });

      dropzone.addEventListener('dragover', function (event) {
        event.preventDefault();
        dropzone.classList.add('drag-over');
      });

      dropzone.addEventListener('dragleave', function (event) {
        if (!dropzone.contains(event.relatedTarget)) {
          dropzone.classList.remove('drag-over');
        }
      });

      dropzone.addEventListener('drop', function (event) {
        event.preventDefault();
        dropzone.classList.remove('drag-over');
        addFiles(event.dataTransfer.files);
      });
    }

    function initAllFileUploaders() {
      document.querySelectorAll('.art-file-uploader__dropzone[data-input-id]').forEach(initFileUpload);
    }

    if (!window.artFileUploaderEmptySubmitGuard) {
      window.artFileUploaderEmptySubmitGuard = true;
      document.addEventListener(
        'submit',
        function (event) {
          const disabledInputs = [];
          event.target
            .querySelectorAll('.art-file-uploader__input:not([required])')
            .forEach(function (input) {
              if (input.files.length === 0) {
                input.disabled = true;
                disabledInputs.push(input);
              }
            });

          window.setTimeout(function () {
            disabledInputs.forEach(function (input) {
              input.disabled = false;
            });
          }, 0);
        },
        true
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllFileUploaders);
    } else {
      initAllFileUploaders();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
